import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  Box,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
const FAQ = () => {
  const { t } = useTranslation();
// Ürünler sayfası için özel SSS verileri
const productFaqData = [
  {
    question:  t("FAQ.productFaqData.question"),
    answer:
    t("FAQ.productFaqData.answer"),
  },
  {
    question: t("FAQ.productFaqData.question2"),
    answer:
    t("FAQ.productFaqData.answer2"),
  },
  {
    question: t("FAQ.productFaqData.question3"),
    answer:
    t("FAQ.productFaqData.answer3"),
  },
];


  const location = useLocation();
  console.log("Şu anki sayfa:", location.pathname); // Yol kontrolü için

  // Sadece "/urunler" sayfasında göster
  if (location.pathname !== "/urunler") {
    return null;
  }

  const faqData = productFaqData; // FAQ verisini belirle

  return (
    <Container maxWidth="xl" sx={{ mt: 5, mb: 5, width: "100%" }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          fontSize: { xs: "1.8rem", md: "2.4rem" },
          color: "#000000",
          textAlign: "center",
          mb: 3,
        }}
      >
        {t('FAQ.title')}
      </Typography>
      <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          textAlign: "center",
          boxShadow: "0px 10px 30px rgba(0,0,0,0.05)",
          width: "100%",
        }}
      >
        <Box mt={2}>
          {faqData.map((faq, index) => (
            <Accordion
              key={index}
              sx={{
                mb: 2,
                borderRadius: 3,
                backgroundColor: "#ffffff",
                boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.13)",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.02)",
                  boxShadow: "0px 5px 20px rgba(0, 0, 0, 0.13)",
                },
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "#000" }} />}
                sx={{
                  backgroundColor: "#f8f8f8",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "#e0e0e0" },
                }}
              >
                <Typography fontWeight="bold" color="#000" sx={{ fontSize: "1.1rem" }}>
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: "#fff", textAlign: "justify" }}>
                <Typography color="#000" sx={{ fontSize: "1rem", lineHeight: 1.7 }}>
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Paper>
    </Container>
  );
};

export default FAQ;
